import createWebStorage from "redux-persist/lib/storage/createWebStorage"

const createNoopStorage = () => ({
  getItem(_key: string) {
    return Promise.resolve(null)
  },
  setItem(_key: string, value: unknown) {
    return Promise.resolve(value)
  },
  removeItem(_key: string) {
    return Promise.resolve()
  },
})

/** localStorage on the client; noop during SSR. */
const persistStorage =
  typeof window !== "undefined" ? createWebStorage("local") : createNoopStorage()

export default persistStorage
